import { UIText3 } from '@cian/ui-kit/typography';
import { clsx } from 'clsx';

import * as styles from './styles.css';

export interface IEscrowLabelProps {
  blue?: boolean;
  dark?: boolean;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export function EscrowLabel({ onClick, blue, dark }: IEscrowLabelProps) {
  return (
    <div
      className={clsx(
        styles['container'],
        styles['escrow'],
        blue && styles['escrow-blue'],
        dark && styles['escrow-dark'],
      )}
      onClick={onClick}
    >
      <UIText3 color={blue ? 'text-main-default' : 'text-primary-default'}>Эскроу</UIText3>
    </div>
  );
}
